<template>
    <div
        class="card-collection"
        :data-wide="wide"
    >
        <Transition name="fade">
            <ClientOnly>
                <template #fallback>
                    <!-- this will be rendered on server side -->
                    <BaseCard
                        v-for="(card, index) in placeholderCount"
                        :key="index"
                        :class="{'card--small' : wide}"
                    >
                        <template #header>
                            <ContentPlaceholdersImg />
                        </template>

                        <template #title>
                            <ContentPlaceholdersHeading />
                        </template>

                        <template
                            v-if="card.meta || card.location"
                            #meta
                        >
                            <ContentPlaceholdersText :lines="2" />
                        </template>

                        <template
                            v-if="card.pills"
                            #footer
                        >
                            <ContentPlaceholdersText :lines="1" />
                        </template>
                    </BaseCard>
                </template>
                <BaseCard
                    v-for="(card, index) in cards"
                    :key="index"
                    :uri="card?.url ? card.url : `/${card.uri}`"
                    :external="!!card?.url"
                    :class="{'card--small' : wide}"
                >
                    <template
                        v-if="card.isCrossPublished && card.handle"
                        #badge
                    >
                        <BaseBadge
                            variant="dark"
                            class="card__badge"
                            icon="arrow-up-right"
                        >
                            {{ capitalize(card.handle) }}
                        </BaseBadge>
                    </template>

                    <template
                        v-if="card.image"
                        #header
                    >
                        <BaseFigure
                            :alt="card.image?.alt || ''"
                            :srcset="card.image?.srcset || getSrcSet(card.image, 'responsive')"
                            sizes="100vw"
                            :src="card.image?.src"
                        />
                    </template>

                    <template #title>
                        {{ card.title }}
                    </template>

                    <template
                        v-if="(card.meta || card.location) && showMeta"
                        #meta
                    >
                        <strong v-if="card.meta">{{ card.meta }}</strong>

                        <div
                            v-if="showLocation && card.location"
                            class="card__location"
                        >
                            {{ card.location }}
                        </div>
                    </template>

                    <template
                        v-if="card.pills"
                        #footer
                    >
                        <template
                            v-for="(pill, pillDex) in card.pills.slice(0, 4)"
                            :key="pillDex"
                        >
                            <BasePill :class="{ 'pill--dark': pill.isDark }">
                                {{ pill.text }}
                            </BasePill>
                            <span
                                v-if="card.pills.length > 4 && pillDex === 3"
                                :key="`hellip${pillDex}`"
                                class="card__footer-hellip"
                            >&hellip;</span>
                        </template>
                    </template>
                </BaseCard>
            </ClientOnly>
        </Transition>
    </div>
</template>

<script setup>
import useSrcSets from '~/utils/srcset';
import {capitalize} from 'lodash-es';
const { getSrcSet } = useSrcSets();

const props = defineProps({
    cards: {
        type: Array,
        default: null,
        required: true
    },
    placeholder: {
        type: Boolean,
        default: false,
        required: false
    },
    placeholderCount: {
        type: Number,
        default: 6,
        required: false
    },
    wide: {
        type: Boolean,
        default: false,
        required: false
    },
    showLocation: {
        type: Boolean,
        default: true,
        required: false
    },
    showMeta: {
        type: Boolean,
        default: true,
        required: false
    }
});

const { placeholder } = toRefs(props);
</script>

<style lang="less">
.card-collection {
    .card-grid();
}

.card-collection[data-wide='true'] {
    .card-grid-wide();
}

.card__location {
    display: block;
    font-weight: var(--font-weight-primary-normal);
}
</style>
